/**
 * Skip-to-content link.
 *
 * Visually hidden until focused, at which point it becomes the first thing a
 * keyboard user reaches on the page. Every layout/header that renders chrome
 * ahead of the page's <main> must render this so keyboard users are not forced
 * to tab through the whole nav on every route.
 *
 * The paired landmark must be `<main id="main-content">`.
 */
export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-accent focus:text-accent-foreground focus:rounded-md focus:text-sm focus:font-medium"
    >
      Skip to content
    </a>
  );
}
